import { Button } from "@tblabs/truffle";


export class PrimaryButton extends Button
{
    constructor(label: string, onClick?: (btn: Button) => void)
    {
        super(label, () => onClick?.(this));
        this.Class("uk-button uk-button-primary")
            .Style("white-space: nowrap;");
    }
}
